import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';

const TIME_OPTIONS = [
  '9am', '10am', '11am', '12pm',
  '1pm', '2pm', '3pm', '4pm',
  '5pm', '6pm', '7pm', '8pm', '9pm',
];

const SinglesRecipient = ({ data, onNext }) => {
  const [form, setForm] = useState({
    recipientName: data.recipientName || '',
    includeDatePlan: data.includeDatePlan || false,
    eventDate: data.eventDate || '',
    eventTime: data.eventTime || '',
    eventLocation: data.eventLocation || '',
  });

  const today = new Date().toISOString().split('T')[0];

  const handleSubmit = (e) => {
    e.preventDefault();
    if (form.recipientName.trim()) {
      onNext(form);
    }
  };

  return (
    <motion.div initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} className="p-6">
      <h2 className="text-2xl font-bold text-gray-800 mb-1">Who is this for? 💌</h2>
      <p className="text-gray-500 text-sm mb-6">Enter their name and optionally plan a date</p>

      <form onSubmit={handleSubmit} className="space-y-5">
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-1">Recipient Name</label>
          <div className="relative">
            <SafeIcon name="Heart" className="absolute left-4 top-1/2 -translate-y-1/2 text-pink-400" />
            <input
              type="text"
              required
              value={form.recipientName}
              onChange={(e) => setForm({ ...form, recipientName: e.target.value })}
              placeholder="Their name"
              className="w-full pl-12 pr-4 py-4 rounded-xl border border-gray-200 focus:border-pink-500 focus:ring-2 focus:ring-pink-100 outline-none"
            />
          </div>
        </div>

        {/* Date Plan Toggle */}
        <button
          type="button"
          onClick={() => setForm({ ...form, includeDatePlan: !form.includeDatePlan })}
          className={`w-full p-4 rounded-xl border-2 transition-all flex items-center gap-3 ${
            form.includeDatePlan ? 'border-pink-500 bg-pink-50' : 'border-gray-200 bg-white'
          }`}
        >
          <div className={`w-12 h-7 rounded-full transition-all flex items-center ${
            form.includeDatePlan ? 'bg-pink-500 justify-end' : 'bg-gray-300 justify-start'
          }`}>
            <div className="w-5 h-5 bg-white rounded-full mx-1 shadow" />
          </div>
          <div className="text-left">
            <p className="font-semibold text-gray-800 text-sm">Include Date Plan?</p>
            <p className="text-xs text-gray-400">Add date, time & location (optional)</p>
          </div>
        </button>

        {form.includeDatePlan && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            className="space-y-4"
          >
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-1">
                <SafeIcon name="Calendar" className="inline mr-1 text-pink-500" /> Date
              </label>
              <input
                type="date"
                min={today}
                value={form.eventDate}
                onChange={(e) => setForm({ ...form, eventDate: e.target.value })}
                className="w-full p-4 rounded-xl border border-gray-200 focus:border-pink-500 focus:ring-2 focus:ring-pink-100 outline-none"
              />
            </div>

            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-1">
                <SafeIcon name="Clock" className="inline mr-1 text-pink-500" /> Time
              </label>
              <div className="grid grid-cols-4 gap-2">
                {TIME_OPTIONS.map((t) => (
                  <button
                    key={t}
                    type="button"
                    onClick={() => setForm({ ...form, eventTime: t })}
                    className={`py-2.5 rounded-lg text-sm font-medium transition-all ${
                      form.eventTime === t
                        ? 'bg-pink-500 text-white shadow-md'
                        : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                    }`}
                  >
                    {t}
                  </button>
                ))}
              </div>
            </div>

            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-1">
                <SafeIcon name="MapPin" className="inline mr-1 text-pink-500" /> Location
                <span className="text-gray-400 font-normal ml-1">(optional)</span>
              </label>
              <input
                type="text"
                value={form.eventLocation}
                onChange={(e) => setForm({ ...form, eventLocation: e.target.value })}
                placeholder="e.g. The café on Main St"
                className="w-full p-4 rounded-xl border border-gray-200 focus:border-pink-500 focus:ring-2 focus:ring-pink-100 outline-none"
              />
            </div>
          </motion.div>
        )}

        <button
          type="submit"
          className="w-full bg-gradient-to-r from-pink-500 to-rose-500 text-white font-bold py-4 rounded-xl shadow-lg shadow-pink-200"
        >
          Continue →
        </button>
      </form>
    </motion.div>
  );
};

export default SinglesRecipient;